import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import {  Modal, Button, Alert, Spinner } from "react-bootstrap";
import axios from "axios";
import Baseurl from "../../../Baseurl";
import { useHistory } from "react-router-dom";
import swal from "sweetalert";
const RiderOrders = (props) => {
  const history=useHistory()
  const { id } = props.match.params;
  const sort = 30;
  const activePag = useRef(0); 
  const [data, setData] = useState([]);
  const [spinner, setSpinner] = useState(true);
  const [test, settest] = useState(0);
  const [show, setShow] = useState(false);
  const [orders, setOrders] = useState([]);
  const handleClose = () => setShow(false);
  const [searchData, setSearchData] = useState([]);
  // Active data
  const chageData = (frist, sec) => {
    for (var i = 0; i < data.length; ++i) {
      if (i >= frist && i < sec) {
        data[i].classList.remove("d-none");
      } else {
        data[i].classList.add("d-none");
      }
    }
  };
function getData(length){
  axios.get(Baseurl.baseurl + `/rider/get-all-live-orders/${id}/${length}`).then((res) => {
    setSpinner(false);
    if(res.data.status){
      res.data.orders.map((val)=>{
      })
      setOrders(
        (oldArray) => oldArray.concat(res.data.orders),
        () => {}
      );
      setSearchData(
        (oldArray) => oldArray.concat(res.data.orders),
        () => {}
      );
      setData(document.querySelectorAll("#job_data tbody tr"))
    }
    else{
      swal("No More orders", "", "error", {
        button: "Done",
        timer: 1000,
      });

    }
  })
  .catch((err) => {
   
})
}

  activePag.current === 0 && chageData(0, sort);
  let paggination = Array(Math.ceil(data.length / sort))
    .fill()
    .map((_, i) => i + 1);
  const onClick = (i) => {
    activePag.current = i;
    chageData(activePag.current * sort, (activePag.current + 1) * sort);
    settest(i);
  };
  useEffect(() => {
    if (data.length > 0) {
      if (props.location.state !== undefined) {
        window.scrollTo({
          top: parseInt(props.location.state.position),
          behavior: "smooth",
        });
      }
      onClick(
        props.location.state === undefined
          ? 0
          : parseInt(props.location.state.pagination)
      );
      setOrders([...orders]);
    }
  }, [data]);
  useEffect(() => {
    if (props.location.state === undefined) {
      getData(orders.length);
    } else {
      setOrders(props.location.state.data);
      setSpinner(false);
      setTimeout(() => {
        setData(document.querySelectorAll("#job_data tbody tr"));
      }, 50);
    }
  }, []);
  function formatDateTime(dateTimeString) {
    const date = new Date(dateTimeString);
    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const year = String(date.getUTCFullYear());
    let hours = date.getUTCHours();
    const minutes = String(date.getUTCMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    const time = `${String(hours).padStart(2, "0")}:${minutes} ${ampm}`;
    return `${day}-${month}-${year} ${time}`;
  }
  return (
    <div className="col-12">
      <Modal size="lg" show={show} onHide={handleClose}>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <div className="card" style={{
                color: "white",
                background:
                  "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
              }}>
        <div className="card-header">
          <h4 className="card-title text-white">Rider orders</h4>
          <div>
            {/* <input
              type="text"
              className="form-control"
              placeholder="Search here..."
              onChange={(e) => {
                searchRider(e.target.value);
              }}
            /> */}
          </div>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <div id="job_data" className="dataTables_wrapper ">
              {spinner ? (
                <div className="text-center">
                  <Spinner animation="border" variant="primary" />
                </div>
              ) : (
                <table
                  className="display w-100 dataTable  "
                  id="myTable"
                  role="grid"
                  aria-describedby="example5_info"
                >
                 <thead>
                    <tr  role="row">
                      <th className="text-white" rowSpan="1" colSpan="1">
                        Date
                      </th>

                      <th className="text-white" rowSpan="1" colSpan="1">
                        Amount
                      </th>
                      <th className="text-white" rowSpan="1" colSpan="1">
                        Name
                      </th>
                      <th className="text-white" rowSpan="1" colSpan="1">
                        Order Status
                      </th>
                      <th className="text-white" rowSpan="1" colSpan="1">
                      Payment
                      </th>
                      <th className="text-white" rowSpan="1" colSpan="1">
                        Action
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                  {orders &&
                      orders.map((order) => (
                        <tr className="odd" role="row" key={order._id}>
                          <td className="sorting_1">{formatDateTime(order.createdAt)}</td>

                          <td className="text-center">₹ {order.Amount}</td>
                          <td>{order.Address[0].Name}</td>
                          <td>{order.OrderStatus}</td>
                          <td>{order.PaidCOD || order.PaidOnline ? "Paid" : "Un-Paid"}</td>
                          <td>
                           
                              <button
                              onClick={()=>{
                                history.push(
                                  `/all-order-list/${order._id}/${
                                    activePag.current
                                  }/${Math.round(window.scrollY)}/riderOrders`,
                                  {orders:orders,riderId:id}
                                );
                              }}
                                className="btn btn-primary"
                              >
                                View
                              </button>
                            
                          </td>
                        </tr>
                      ))}
                    
                  </tbody>
                </table>
              )}
              {!orders && (
                <Alert
                  variant="success"
                  className="alert-dismissible fade show text-center"
                >
                  Zero Orders
                </Alert>
              )}
              <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
                <div className="dataTables_info text-white">
                  Showing {activePag.current * sort + 1} to{" "}
                  {data.length > (activePag.current + 1) * sort
                    ? (activePag.current + 1) * sort
                    : data.length}{" "}
                  of {data.length} entries
                </div>
                <div
                  className="dataTables_paginate paging_simple_numbers"
                  id="example5_paginate"
                >
                  <Link
                    className="paginate_button previous disabled"
                    onClick={() =>
                      activePag.current > 0 && onClick(activePag.current - 1)
                    }
                  >
                    Previous
                  </Link>
                  <span>
                    {paggination.map((number, i) => (
                      <Link
                        key={i}
                        className={`paginate_button  ${
                          activePag.current === i ? "current" : ""
                        } `}
                        onClick={() => onClick(i)}
                      >
                        {number}
                      </Link>
                    ))}
                  </span>
                  <Link
                    className="paginate_button next"
                    onClick={() => {
                      activePag.current + 1 < paggination.length &&
                        onClick(activePag.current + 1);
                    }}
                  >
                    Next
                  </Link>
                  <button onClick={()=>{
               
               getData(orders.length)
               }} className="btn btn-primary ml-2">Next</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RiderOrders;
